import { giphyBlack, giphyLightGrey, giphyWhite } from '@giphy/js-brand'
import React from 'react'
import { Button } from 'shared/components/buttons'
import Modal from 'shared/components/modal/modal'
import { Title } from 'shared/components/text-elements'
import styled from 'styled-components'

const Container = styled.div`
    position: relative;
    background: ${giphyBlack};
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    max-width: 545px;
    padding: 35px;
`

const Character = styled.img`
    position: absolute;
    height: 130px;
    top: -104px;
    left: 40%;
`

const ModalTitle = styled(Title)`
    font-size: 22px;
    margin: 25px 25px 0;
    width: 260px;
`

const Blurb = styled.div`
    margin: 15px 0 25px;
    opacity: 0.9;
`

const Buttons = styled.div`
    display: flex;
`
const Footer = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 25px;
    font-size: 14px;

    a {
        color: ${giphyLightGrey};
        padding-bottom: 1px;
        border-bottom: 1px solid ${giphyLightGrey};
    }
`

const ButtonLink = styled(Button)`
    color: ${giphyWhite};
    font-size: 16px;

    &:first-child {
        margin-right: 7px;
        padding: 0 30px;
    }
`

const LoginModal = () => (
    <Modal>
        <Container>
            <Character src="https://s3.amazonaws.com/giphygifs/media/61Y9cThgDSSz8b2zc6/200.gif?cid=790b7611e8f99291df8d357e26b897342cbe84adc5221394&rid=200.gif" />
            <ModalTitle>You&#39;ve gotta log in to upload to GIPHY!</ModalTitle>
            <Blurb>
                We&#39;re trying to make the internet a safer place. Sign in or create a GIPHY account to upload content
                to your GIPHY channel.
            </Blurb>
            <Buttons>
                <ButtonLink as="a" href={`/login?next=${location.pathname}`}>
                    Log In
                </ButtonLink>
                <ButtonLink as="a" href={`/join?next=${location.pathname}`}>
                    Create an Account
                </ButtonLink>
            </Buttons>
            <Footer>
                <a href={'/'}>Or return home</a>
            </Footer>
        </Container>
    </Modal>
)

export default LoginModal
